import { PARTNER_CATEGORIES, type PartnerCategory } from './categories';

/**
 * Slug-контракт приёма из калькулятора (Блок 12 → Блок 8, ADR-0080 §8.1, Фаза F2).
 * COORD `COORD_Партнёры→Калькулятор_2026-06-14.md`.
 *
 * Калькулятор шлёт стабильный латинский `?category=<slug>`; каталог (НАША сторона)
 * мапит slug → каноничную(ые) русскую категорию(и) для фильтра. Каноничные имена —
 * **вербатим** из `PARTNER_CATEGORIES` (P-001: никакой нормализации, связь с именами
 * фото партнёров в R2 ломается при любой замене символов).
 *
 * 11 одиночных slug-ов + агрегированный **`facades-radius` → ДВЕ категории**
 * («Фасады плёнка» + «Фасады краска»; шпон к радиусным НЕ применим — решение Aibek
 * 2026-06-14, Вариант B). Резолв `facades-radius` отдаёт объединённый список обеих
 * категорий (merge во фронте, см. PartnersList; контракт `partners` не меняется).
 *
 * Неизвестный/отсутствующий slug → `null` → обычный экран категорий 2.8.1 (текущее
 * поведение `/partners` preserved). Whitelist-резолв = anti-injection (security У6):
 * в фильтр уходят только значения из этой карты, не произвольный ввод из URL.
 */
export const CATEGORY_SLUGS: Record<string, readonly PartnerCategory[]> = {
  cutting: ['Распил, закатка, присадка'],
  'facades-film': ['Фасады плёнка'],
  'facades-paint': ['Фасады краска'],
  'facades-veneer': ['Фасады шпон'],
  'mdf-milling': ['МДФ фрезеровка (черновые фасады)'],
  stone: ['Каменщики'],
  glass: ['Зеркала / стёкла / витрины'],
  upholstered: ['Мягкая мебель'],
  lighting: ['Подсветка'],
  delivery: ['Газели'],
  loaders: ['Грузчики'],
  // Агрегат (Вариант B): радиусный фасад делается подрядчиками плёнки И краски.
  'facades-radius': ['Фасады плёнка', 'Фасады краска'],
};

/**
 * Резолв slug → каноничные категории. Неизвестный/пустой slug → `null` (caller
 * показывает обычный экран категорий). Возвращаемые имена гарантированно входят в
 * `PARTNER_CATEGORIES` (статически — карта типизирована `PartnerCategory[]`).
 */
export function resolveCategorySlug(
  slug: string | null | undefined,
): readonly PartnerCategory[] | null {
  if (!slug) return null;
  return CATEGORY_SLUGS[slug] ?? null;
}

// Контроль целостности карты: каждое значение — реальная каноничная категория (P-001).
// Не рантайм-проверка, а сторож от опечатки при правке карты (читается тестом).
export const CATEGORY_SLUGS_TARGETS_VALID = Object.values(CATEGORY_SLUGS)
  .flat()
  .every((c) => (PARTNER_CATEGORIES as readonly string[]).includes(c));
